import { atom } from 'jotai';

import { DeliveryMethod } from '../DeliveryMethod';

type DeliveryMethodSettings = Record<DeliveryMethod, boolean> & {
  rosteredRoomSetting: boolean;
};

/**
 * This is an atom used to store a launch setting.
 * Since the launch settings have different values when the delivery method changes
 * this takes in a record which configures the different values for each delivery method.
 */
export function launchSettingAtom(settings: DeliveryMethodSettings) {
  const initialValue = settings[DeliveryMethod.InstantFeedback];
  const internalAtom = atom<boolean>(initialValue);
  return atom<
    boolean,
    [value: boolean | DeliveryMethod, isRoomRostered?: boolean],
    void
  >(
    (get) => get(internalAtom),
    (_get, set, value, isRoomRostered = false) => {
      if (typeof value === 'boolean') {
        set(internalAtom, value);
      } else {
        const defaultValue = settings[value];
        set(
          internalAtom,
          isRoomRostered ? settings.rosteredRoomSetting : defaultValue
        );
      }
    }
  );
}
